import { cn } from "../../lib/utils"
import { Card, CardContent, CardHeader, CardTitle } from "./card"
import { ExternalLink } from "lucide-react"

interface TransparentCardProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string
  subtitle?: string
  externalLink?: string
  image?: {
    src: string
    alt: string
  }
  customComponent?: React.ReactNode
}

const TransparentCard = ({
  className,
  title,
  subtitle,
  externalLink,
  image,
  customComponent,
  ...props
}: TransparentCardProps) => {
  return (
    <Card
      className={cn(
        "bg-transparent backdrop-blur-none border-foreground relative",
        className
      )}
      {...props}
    >
      <CardHeader className="p-4">
        {title && (
          <CardTitle className="text-xl text-foreground">
            {title}
          </CardTitle>
        )}
      </CardHeader>
      <CardContent className="p-4 pt-0">
        {subtitle && (
          <div 
            className="text-sm text-foreground"
            dangerouslySetInnerHTML={{ __html: subtitle }}
          />
        )}
        {image && (
          <div className="flex-grow flex items-center justify-center mt-2">
            <div className="relative w-full h-full">
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-auto object-contain"
                loading="lazy"
              />
            </div>
          </div>
        )}
        {customComponent && (
          <div className="flex-grow flex items-center justify-center mt-2">
            {customComponent}
          </div>
        )}
        {externalLink && (
          <a 
            href={externalLink} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="absolute top-4 right-4 text-foreground hover:text-foreground/80 transition-colors duration-200"
          >
            <ExternalLink size={20} />
          </a>
        )}
      </CardContent>
    </Card>
  )
}

export default TransparentCard 